import React from "react";
import Select, { components } from "react-select";
import { Checkbox } from "semantic-ui-react";
import "./GoalsDropdown.scss";

const Option = ({ innerProps, ...props }) => {
    // console.log(props);
    // console.log(innerProps);
    return (
        <div>
            <components.Option {...props} innerProps={innerProps}>
                <Checkbox
                    className="goals__checkbox"
                    checked={props.isSelected}
                    onClick={() => {
                        props.selectOption(props.data);
                    }}
                    label={""}
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                />
                <div>
                    <p className="option-heading" onClick={() => {}}>
                        {props.label}
                    </p>
                    <p className="option-desc" onClick={() => {}}>
                        {props.data.desc}
                    </p>
                </div>
            </components.Option>
        </div>
    );
};
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: "transparent",
        color: "#1f2e3d",
        // padding: 8,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        ":hover": {
            backgroundColor: "#B2D4FF",
        },
        ":active": {
            backgroundColor: "transparent",
        },
    }),
    multiValue: (provided, state) => ({
        ...provided,
        backgroundColor: "#E1E1E2",
        color: "#1f2e3d",
        // padding: 8,
        fontSize: 14,
    }),
};

const GoalsDropdown = (props) => {
    return (
        <>
            <Select
                menuPlacement={props.menuPlacement}
                className={`goals__dropdown ${props.className ? props.className : ""}`}
                placeholder={props.placeholder}
                components={{
                    // ValueContainer,
                    Option,
                }}
                onChange={props.onChange}
                styles={customStyles}
                options={props.options}
                onKeyDown={props.onKeyDown}
                isMulti
                closeMenuOnSelect={false}
                // menuIsOpen={true}
                value={props.value}
                hideSelectedOptions={false}
                blurInputOnSelect={false}
            />
        </>
    );
};

export default GoalsDropdown;
